/** Apelido opcional do endereço (AddressDTO.name). */
export const ADDRESS_NAME_MAX_LENGTH = 100;

export const ADDRESS_NAME_TOOLTIP =
    'Opcional. Apelido do endereço para identificá-lo com facilidade (ex.: Matriz, Galpão 2). Não precisa ser único e não entra na detecção de endereço duplicado.';

export const ADDRESS_PLACE_COLUMN_TOOLTIP =
    'Exibe o nome quando ele estiver preenchido. Se o nome for nulo, exibe o logradouro, que sempre está presente.';

/**
 * @param {unknown} value
 * @returns {string|null}
 */
export function normalizeAddressName(value) {
    const trimmed = value == null ? '' : String(value).trim();
    return trimmed || null;
}

/**
 * @param {unknown} value
 * @returns {string|null}
 */
export function addressNameError(value) {
    const trimmed = value == null ? '' : String(value).trim();
    if (trimmed.length > ADDRESS_NAME_MAX_LENGTH) {
        return `Nome deve ter no máximo ${ADDRESS_NAME_MAX_LENGTH} caracteres.`;
    }
    return null;
}

/**
 * Texto da coluna Nome/Logradouro: nome quando preenchido; senão, logradouro.
 * @param {{ name?: string|null, street?: string|null }|null|undefined} item
 * @returns {string}
 */
export function addressPlaceLabel(item) {
    const name = item?.name != null ? String(item.name).trim() : '';
    if (name) return name;
    const street = item?.street != null ? String(item.street).trim() : '';
    return street || '—';
}

/**
 * Localiza `address.name` / `responsibleAddress.name` no campo de apelido,
 * sem confundir com o nome da pessoa.
 * @param {string} location
 * @returns {string|null}
 */
export function mapAddressAliasLocation(location) {
    const t = String(location || '').trim();
    if (/(^|\.)address\.name$/.test(t) || /(^|\.)responsibleAddress\.name$/.test(t)) {
        return 'addressName';
    }
    return null;
}

/**
 * @param {string} location
 * @returns {string|null}
 */
export function mapApiLocationKeepingAddressAlias(location) {
    const alias = mapAddressAliasLocation(location);
    if (alias) return alias;
    const parts = String(location || '').split('.').filter(Boolean);
    return parts.length ? parts[parts.length - 1] : null;
}
